import api from "@/lib/api";
import type { ApiDilemma } from "@/features/dilemmas/types";
import type { AiGenerateRequest, AiRefineRequest } from "../types";

// generate/refine appellent Mistral et peuvent durer jusqu'à 60 s :
// on surcharge le timeout global (10 s) pour ces requêtes.
const AI_REQUEST_TIMEOUT_MS = 60000;

const AI_WRITING_ASSISTANT_ENDPOINTS = {
  GENERATE: "/dilemmas/generate/",
  REFINE: (id: string) => `/dilemmas/${id}/refine/`,
};

export class AiWritingAssistantHttpRepository {
  async generate(payload: AiGenerateRequest): Promise<ApiDilemma> {
    const result = await api.post(
      AI_WRITING_ASSISTANT_ENDPOINTS.GENERATE,
      payload,
      { timeout: AI_REQUEST_TIMEOUT_MS },
    );
    return result.data;
  }

  async refine(id: string, payload: AiRefineRequest): Promise<ApiDilemma> {
    const result = await api.patch(
      AI_WRITING_ASSISTANT_ENDPOINTS.REFINE(id),
      payload,
      { timeout: AI_REQUEST_TIMEOUT_MS },
    );
    return result.data;
  }
}
